"use client"; 

import React, { useState, useEffect } from "react";
import { PageTitleHeader, PageSectionHeader, usePixelatedConfig } from "@pixelated-tech/components";
import { PageSection, PageGridItem } from "@pixelated-tech/components";
import { Callout } from "@pixelated-tech/components";
import { SocialTags } from "@pixelated-tech/components";
import * as CalloutLibrary from "@/app/elements/calloutlibrary";
import { Hero, getContentfulVideoMetadata } from "@pixelated-tech/components";
import { BlogPostList } from "@pixelated-tech/components";

export default function Home() {
	const pixelatedConfig = usePixelatedConfig();
	const [heroVideo, setHeroVideo] = useState<string>();
	const [heroVideoMeta, setHeroVideoMeta] = useState<{ title?: string; description?: string; uploadDate?: string; duration?: string; poster?: string }>({});

	const videos = [
		"https://videos.ctfassets.net/ank9sh265hdu/4rxGU5MYRZtZcfD0b7nq1j/1a4a9f7a7f8f4f5e6de7aae53796f024/0_Animation_Network_Connection.mp4",
		"https://videos.ctfassets.net/ank9sh265hdu/4rukYNzKrmBTrM7r2AWcxw/eca6e2aa323209ce3949593a7a1c1a50/0_People_Animation.mp4",
		"https://videos.ctfassets.net/ank9sh265hdu/7kdjRW4ARgZpk2Zuslt2bN/e81d09990e04c660612462e3466c0383/1294192_App_Application.mp4",
		"https://videos.ctfassets.net/ank9sh265hdu/5CfnOgx8k1Gqq0xXDlyJpd/108a865ae94f4c521fe4cfbd63cdd9b0/GettyImages-1251562713.mp4",
		"https://videos.ctfassets.net/ank9sh265hdu/6kj4wZu4VRAupq78sYhA9D/f2c378598ba552197884be5e29e1e0c3/GettyImages-675750094.mp4",
	];
	useEffect(() => {
		setHeroVideo(videos[Math.floor(Math.random() * videos.length)]);
		setHeroVideoMeta({});
	}, []);

	useEffect(() => {
		if (!heroVideo) {
			return;
		}

		let cancelled = false;
		getContentfulVideoMetadata(heroVideo, pixelatedConfig?.integrations?.contentful)
			.then((metadata) => {
				if (cancelled || !metadata) return;
				setHeroVideoMeta({
					...metadata,
				});
			})
			.catch(() => undefined);

		return () => {
			cancelled = true;
		};
	}, [heroVideo]);

	return (
		<>

			<Hero 
				variant="video"
				// video="/videos/GettyImages-1251562713.mp4"
				{...heroVideoMeta}
				video={heroVideo}
				height="40vh"
			/>

			<PageTitleHeader title="Pixelated Technologies" />
			<PageSection id="pixelated-section" maxWidth="768px" columns={1}>
				<PageGridItem>
					<Callout
						aboveFold={true}
						layout='vertical' 
						imgAlt='Pixelated Technologies'
						imgShape="squircle" 
						subtitle="About Pixelated Technologies"
						content='Pixelated Technologies is a Digital Services company that specializes in transforming small businesses through custom IT solutions, including web development, social media marketing, search engine optimization, content management, eCommerce solutions, and small business modernization. Our mission is to empower small businesses to thrive in the digital age by providing tailored technology services that drive growth and efficiency.'/>
				</PageGridItem>
			</PageSection>

			<PageSection columns={1} maxWidth="1024px" id="home-schedule-section" >
				<PageGridItem>
					<CalloutLibrary.scheduleAppointment 
						variant='boxed grid'
						layout='horizontal'
					/>
				</PageGridItem>
			</PageSection>

			<PageSection columns={2} maxWidth="1024px"id="spotlight-section">

				<PageGridItem>
					<Callout
						layout='vertical'
						url='/portfolio'
						img='https://images.ctfassets.net/ank9sh265hdu/5o6Znbm8NrLxnAYNigmZ9v/1c86b278e3c15271d452c3a4d25ff1c2/portfolio.jpg?fm=webp'
						imgAlt='Portfolio'
						imgShape='bevel'
						title='View Our Work Portfolio'
						content='Explore the Pixelated Technologies portfolio to see examples of the web development and design work delivered by our team members over the years. From responsive websites and custom web applications to branding and logo designs, our portfolio showcases the diverse range of projects we have successfully completed for small businesses. Discover how Pixelated Technologies can bring your vision to life with tailored solutions that meet your unique needs.'/>
				</PageGridItem>

				<PageGridItem>
					<Callout
						layout='vertical'
						url='/samples'
						img='https://images.ctfassets.net/ank9sh265hdu/6eYGISUKzCqZnQ7J9uASQK/a31c298d8a6e4da5c174a9615e9cb1e8/samples.jpg?fm=webp'
						imgAlt='Samples'
						imgShape='bevel'
						title='View Some Samples'
						content="Take a look at some of the Pixelated Technologies web design samples to get an idea of the quality and style we bring to our projects. Examples include a landscape company website, a wedding photographer, a local restaurant menu, a bicycle shop, and a taco food truck.  These samples are just a few examples of how Pixelated Technologies can create visually appealing and user-friendly websites tailored to your industry. No matter your industry, we have experience creating custom web solutions that can help your business succeed online."/>
				</PageGridItem>
			</PageSection>

			
			<PageSection id="recent-blog-section" columns={1} background="var(--secondary-color)" >
				<SocialTags />
				<PageSectionHeader title="Read Our Most Recent Blog Post" />
				<BlogPostList count={1} showCategories={false}  />
			</PageSection>

			<PageSectionHeader title="Our Value Proposition" />
			<PageSection id="products-section" columns={1}>
				<PageGridItem >
					<Callout
						aboveFold={true}
						variant="boxed"
						layout='horizontal' 
						direction="left"
						img='https://images.ctfassets.net/ank9sh265hdu/4rEaVj4s5osjtd00QSmpBb/a6bce8b9f61c15431754dcfee2e86907/webdev.jpg?fm=webp'
						imgAlt='Web Development'
						title='Web Development'
						subtitle='Do you need a new website or web application for your business? Is your current website outdated or not mobile-friendly? Have you focused on other parts of your business and need help with your online presence?' 
						content='Pixelated Technologies can be your Virtual Technology Department, providing custom web development solutions tailored to your business needs.  We specialize in creating responsive, user-friendly websites and web applications that help small businesses succeed online.'/>
				</PageGridItem>
				<PageGridItem >
					<Callout
						aboveFold={true}
						variant="boxed"
						layout='horizontal' 
						direction="right"
						img='https://images.ctfassets.net/ank9sh265hdu/7CWE8PYdFYNsgMUdauCtRO/6ea882244e904c63c5540e43885709d2/socialmedia.jpg?fm=webp'
						imgAlt='Social Media Marketing'
						title='Social Media Marketing'
						subtitle='Are your social media accounts active and engaging?
							Are they integrated with your website and other online platforms?
							Do they help convert prospective customers into current customers?' 
						content='Let Pixelated Technologies help you develop a comprehensive social media strategy that aligns with your business goals.
							We can help you create and manage your social media accounts, 
							produce engaging content, and analyze performance metrics to optimize your social media presence.' />
				</PageGridItem>
				<PageGridItem >
					<Callout
						aboveFold={true}
						variant="boxed"
						layout='horizontal' 
						direction="left"
						img='https://images.ctfassets.net/ank9sh265hdu/9YlHjpOEN66FuLTmCKIwT/41ba7b315fceef615761a40a44d913da/seo.jpg?fm=webp'
						imgAlt='Search Engine Optimization'
						title='Search Engine Optimization'
						subtitle='Is your website optimized for search engines?
							Does it stand out from your competition, ranking well for relevant keywords and phrases?
							Do you have a plan to improve your search engine rankings over time?' 
						content='Pixelated Technologies can help you improve your websites visibility and ranking on popular search engines.
							We can conduct a thorough SEO audit of your website, identify areas for improvement,
							and implement on-page and off-page SEO strategies to boost your search engine performance.' />
				</PageGridItem>
				<PageGridItem >
					<Callout
						variant="boxed"
						layout='horizontal' 
						direction="right"
						img='https://images.ctfassets.net/ank9sh265hdu/4742vZFZ8ZYfNxDMKijzDQ/4533e5d62f5563358ae25b56593dc664/content.jpg?fm=webp'
						imgAlt='Content Management'
						title='Content Management'
						subtitle='Do you have to rely on a web developer to make updates to your website?
							Would you like to be able to make updates yourself, without needing technical skills?
							Do you need a content management system that is easy to use and maintain?' 
						content='Pixelated Technologies can help you implement a content management system (CMS) that allows you to easily update and manage your website content. We can help you choose the right CMS at the right cost for your business needs, set it up, and provide training and support to ensure you can manage your website effectively.'  />
				</PageGridItem>
				<PageGridItem >
					<Callout
						variant="boxed"
						layout='horizontal' 
						direction="left"
						img='https://images.ctfassets.net/ank9sh265hdu/22E0F5qutkuHS9J4xJeG4r/7fa4e187d3f86ca07acaf5af14d8ae3e/ecommerce.jpg?fm=webp'
						imgAlt='eCommerce Solutions'
						title='eCommerce Solutions'
						subtitle='Do you want to move your business online to 
							sell your products or services digitally?
							Do you need a secure and reliable eCommerce platform that integrates with your existing systems?
							Are you looking for ways to improve your online sales and customer experience?' 
						content='Pixelated Technologies can help you set up and manage an eCommerce platform that meets your business needs.
							We can help you choose the right eCommerce solution, 
							set it up, and provide ongoing support to ensure your online store runs smoothly.' />
				</PageGridItem>
				<PageGridItem >
					<Callout
						variant="boxed"
						layout='horizontal' 
						direction="right"
						img='https://images.ctfassets.net/ank9sh265hdu/6d6ljEpeynadx8ONlRAosp/639ac8aa9561555970f504fcf8d6ba6f/modernization.jpg?fm=webp'
						imgAlt='Small Business Modernization'
						title='Small Business Modernization'
						subtitle='Are you looking to integrate your site with other business systems,
							such as marketing automation tools, billing and finance systems, 
							scheduling or inventory systems, or other business applications?' 
						content='Pixelated Technologies can help you develop custom business solutions that streamline your operations and improve your efficiency. We can work with you to understand your business processes, identify areas for improvement, and develop custom software solutions that meet your specific needs.' />
				</PageGridItem>
			</PageSection>

			<PageSection columns={1} maxWidth="768px" background="var(--accent1-color)" id="spotlight-section">
				<PageGridItem>
					<Callout
						variant='boxed'
						layout='horizontal' 
						img='/images/brianwhaley-headshot.jpg'
						imgAlt='Brian T. Whaley'
						title='Brian T. Whaley'
						content='The owner of Pixelated Technologies.
							Full Stack Developer, Passionate Technologist, 
							Digital Transformation Professional, 
							User Experience Champion, SEO and Social Media Ninja, 
							Landscape and Macro Photographer, Avid World Traveler,
							Advanced Open Water Scuba Diver, Enthusiast of Home-Cooked Food' />
				</PageGridItem>
			</PageSection>
		</>
	);
}
